<template>
  <!--begin::Modal - Create App-->
  <div
    class="modal fade"
    id="kt_modal_activate_ai"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-900px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2>Activate Business AI</h2>
          <!--end::Modal title-->

          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->

        <!--begin::Modal body-->
        <div class="modal-body py-lg-10 px-lg-10">
          <!--begin::Stepper-->
          <div
            class="stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid"
            id="kt_modal_activate_ai_stepper"
            ref="createAppRef"
          >
            <!--begin::Aside-->
            <div
              class="d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px"
            >
              <!--begin::Nav-->
              <div class="stepper-nav ps-lg-10">
                <!--begin::Step 1-->
                <div class="stepper-item current" data-kt-stepper-element="nav">
                  <!--begin::Line-->
                  <div class="stepper-line w-40px"></div>
                  <!--end::Line-->

                  <!--begin::Icon-->
                  <div class="stepper-icon w-40px h-40px">
                    <i class="stepper-check fas fa-check"></i>
                    <span class="stepper-number">1</span>
                  </div>
                  <!--end::Icon-->

                  <!--begin::Label-->
                  <div class="stepper-label">
                    <h3 class="stepper-title">
                      Details
                    </h3>

                    <div class="stepper-desc">
                      Name of Business
                    </div>
                  </div>
                  <!--end::Label-->
                </div>
                <!--end::Step 1-->

                <!--begin::Step 2-->
                <div class="stepper-item" data-kt-stepper-element="nav">
                  <!--begin::Line-->
                  <div class="stepper-line w-40px"></div>
                  <!--end::Line-->

                  <!--begin::Icon-->
                  <div class="stepper-icon w-40px h-40px">
                    <i class="stepper-check fas fa-check"></i>
                    <span class="stepper-number">2</span>
                  </div>
                  <!--begin::Icon-->

                  <!--begin::Label-->
                  <div class="stepper-label">
                    <h3 class="stepper-title">
                      Owner's Info
                    </h3>

                    <div class="stepper-desc">
                      Define owner information
                    </div>
                  </div>
                  <!--begin::Label-->
                </div>
                <!--end::Step 2-->

                <!--begin::Step 3-->
                <div class="stepper-item" data-kt-stepper-element="nav">
                  <!--begin::Line-->
                  <div class="stepper-line w-40px"></div>
                  <!--end::Line-->

                  <!--begin::Icon-->
                  <div class="stepper-icon w-40px h-40px">
                    <i class="stepper-check fas fa-check"></i>
                    <span class="stepper-number">3</span>
                  </div>
                  <!--end::Icon-->

                  <!--begin::Label-->
                  <div class="stepper-label">
                    <h3 class="stepper-title">
                      Address
                    </h3>

                    <div class="stepper-desc">
                      Business Address
                    </div>
                  </div>
                  <!--end::Label-->
                </div>
                <!--end::Step 3-->

                <!--begin::Step 4-->
                <div class="stepper-item" data-kt-stepper-element="nav" v-if="formData.encodingType !== 'activation'">
                  <!--begin::Line-->
                  <div class="stepper-line w-40px"></div>
                  <!--end::Line-->

                  <!--begin::Icon-->
                  <div class="stepper-icon w-40px h-40px">
                    <i class="stepper-check fas fa-check"></i>
                    <span class="stepper-number">4</span>
                  </div>
                  <!--end::Icon-->

                  <!--begin::Label-->
                  <div class="stepper-label">
                    <h3 class="stepper-title">
                      Network Info
                    </h3>

                    <div class="stepper-desc">
                      Provide network details
                    </div>
                  </div>
                  <!--end::Label-->
                </div>
                <!--end::Step 4-->

                <!--begin::Step 5-->
                <div class="stepper-item" data-kt-stepper-element="nav">
                  <!--begin::Line-->
                  <div class="stepper-line w-40px"></div>
                  <!--end::Line-->

                  <!--begin::Icon-->
                  <div class="stepper-icon w-40px h-40px">
                    <i class="stepper-check fas fa-check"></i>
                    <span class="stepper-number"><i class="fas fa-flag-checkered"></i></span>
                  </div>
                  <!--end::Icon-->

                  <!--begin::Label-->
                  <div class="stepper-label">
                    <h3 class="stepper-title">
                      Review
                    </h3>

                    <div class="stepper-desc">
                      Review and Submit
                    </div>
                  </div>
                  <!--end::Label-->
                </div>
                <!--end::Step 5-->
              </div>
              <!--end::Nav-->
            </div>
            <!--begin::Aside-->

            <!--begin::Content-->
            <div class="flex-row-fluid py-lg-5 px-lg-15">
              <!--begin::Form-->
              <form
                class="form"
                novalidate="novalidate"
                id="kt_modal_activate_ai_form"
                @submit="handleStep"
              >
                <!--begin::Step 1-->
                <div class="current" data-kt-stepper-element="content">
                  <div class="w-100">
                    <!--begin::Input group-->
                    <div class="fv-row mb-10">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-5 fw-bold mb-2"
                      >
                        <span class="required">Business Name</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify business name"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <!--begin::Input-->
                      <Field
                        type="text"
                        class="form-control form-control-lg form-control-solid"
                        name="businessName"
                        placeholder=""
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="businessName"
                      />
                      <!--end::Input-->
                    </div>
                    <!--end::Input group-->


                    <!--begin::Illustration-->
                    <div class="text-center px-4 py-15">
                      <img
                        src="media/ai247.jpg"
                        alt=""
                        class="mw-200 mh-250px"
                      />
                    </div>
                    <!--end::Illustration-->
                    
                  </div>
                </div>
                <!--end::Step 1-->

                <!--begin::Step 2-->
                <div data-kt-stepper-element="content">
                  <div class="w-100">
                    <!--begin::Input group-->
                    <div class="fv-row">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-5 fw-bold mb-4"
                      >
                        <span class="required">Owner's details</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify your apps framework"
                        ></i>
                      </label>
                      <!--end::Label-->
 
 
                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">First Name</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Owner's First Name"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="prospectFirstName"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="prospectFirstName"
                      />
                    </div>
                    <!--end::Input group-->
 
 
                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Last Name</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Owner's Last Name"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="prospectLastName"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="prospectLastName"
                      />
                    </div>
                    <!--end::Input group-->
 
 
                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Email Address</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Owner's Email Address"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="prospectEmail"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="prospectEmail"
                      />
                    </div>
                    <!--end::Input group-->

 
 

                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="framework"
                      />
                    </div>
                    <!--end::Input group-->
                  </div>
                </div>
                <!--end::Step 2-->

                <!--begin::Step 3-->
                <div data-kt-stepper-element="content">
                  <div class="w-100"> 

                    <!--begin::Input group-->
                    <div class="fv-row">  

                        <!--begin::Input group-->
                        <div class="row mb-6">
                            <!--begin::Label-->
                            <label class="col-lg-4 col-form-label fw-bold fs-6">
                            <span class="required">Contact Phone</span>

                            <i
                                class="fas fa-exclamation-circle ms-1 fs-7"
                                data-bs-toggle="tooltip"
                                title="Phone number must be active"
                            ></i>
                            </label>
                            <!--end::Label-->

                            <!--begin::Col-->
                            <div class="col-lg-8 fv-row">
                            <Field
                                type="tel" 
                                class="form-control form-control-lg form-control-solid"
                                placeholder="Phone number"
                                name="prospectContactPhone"
                            />

 

                            <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                <ErrorMessage name="phone" />
                                </div>
                            </div>
                            </div>
                            <!--end::Col-->
                        </div>
                        <!--end::Input group-->

                        <!--begin::Input group-->
                        <div class="row mb-6">
                            <!--begin::Label-->
                            <label class="col-lg-4 col-form-label fw-bold fs-6"
                            >Address Line 1</label
                            >
                            <!--end::Label-->

                            <!--begin::Col-->
                            <div class="col-lg-8 fv-row">
                            <Field
                                type="text" 
                                class="form-control form-control-lg form-control-solid"
                                placeholder="Street address, name of building, suite, unit, floor, etc"
                                name="companyAddress"
                            />
                            <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                <ErrorMessage name="website" />
                                </div>
                            </div>
                            </div>
                            <!--end::Col-->
                        </div>
                        <!--end::Input group-->

                        <!--begin::Input group-->
                        <div class="row mb-6">
                            <!--begin::Label-->
                            <label class="col-lg-4 col-form-label fw-bold fs-6">
                            <span class="required">Country</span>

                            <i
                                class="fas fa-exclamation-circle ms-1 fs-7"
                                data-bs-toggle="tooltip"
                                title="Country of origination"
                            ></i>
                            </label>
                            <!--end::Label-->

                            <!--begin::Col-->
                            <div class="col-lg-8 fv-row">
                            <Field
                              as="select"
                              name="country"
                              class="form-select form-select-solid form-select-lg fw-bold"
                              v-model="formData.country"
                              @change="getCities(formData.country)"
                            >
                              <option   :value="''" :label="''">  </option>
                              <option v-for="country in countries" :key="country.iso_code_2" :value="country.country_id" :label="country.name"> 
                              </option>
                            </Field>
                            <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                <ErrorMessage name="country" />
                                </div>
                            </div>
                            </div>
                            <!--end::Col--> 

                        </div>
                        <!--end::Input group-->

                        <!--begin::Input group-->
                        <div class="row mb-6">
                            <!--begin::Label-->
                            <label class="col-lg-4 col-form-label fw-bold fs-6">
                            <span class="required">State/Province</span>

                            <i
                                class="fas fa-exclamation-circle ms-1 fs-7"
                                data-bs-toggle="tooltip"
                                title="State/Province"
                            ></i>
                            </label>
                            <!--end::Label-->

                            <!--begin::Col-->
                            <div class="col-lg-8 fv-row">
                            <Field
                              as="select"
                              name="countryState"
                              class="form-select form-select-solid form-select-lg fw-bold"
                              
                            >
                            <option
                                v-for="i in cities"
                                :key="i"
                                :label="i.name"
                                :value="i.zone_id"
                              >
                              </option>

                            </Field>
                            <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                <ErrorMessage name="countryState" />
                                </div>
                            </div>
                            </div>
                            <!--end::Col--> 

                        </div>
                        <!--end::Input group-->




                        <!--begin::Input group-->
                        <div class="row mb-6">
                            <!--begin::Label-->
                            <label class="col-lg-4 col-form-label fw-bold fs-6">
                            <span class="required">City</span>
 
                            </label>
                            <!--end::Label-->

                            <!--begin::Col-->
                            <div class="col-lg-8 fv-row">
                            <Field
                                type="tel"
                                name="city"
                                class="form-control form-control-lg form-control-solid"
                                placeholder="City" 
                            />
                            <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                <ErrorMessage name="phone" />
                                </div>
                            </div>
                            </div>
                            <!--end::Col-->
                        </div>
                        <!--end::Input group-->

                        <!--begin::Input group-->
                        <div class="row mb-6">
                            <!--begin::Label-->
                            <label class="col-lg-4 col-form-label fw-bold fs-6">
                            <span class="required">Postal Code</span>

                            <i
                                class="fas fa-exclamation-circle ms-1 fs-7"
                                data-bs-toggle="tooltip"
                                title="Postal Code"
                            ></i>
                            </label>
                            <!--end::Label-->

                            <!--begin::Col-->
                            <div class="col-lg-8 fv-row"> 

                            <Field
                                type="text" 
                                class="form-control form-control-lg form-control-solid"
                                placeholder="Postal Code"
                                name="postalCode"
                            />


                            <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                <ErrorMessage name="postalCode" />
                                </div>
                            </div>
                            </div>
                            <!--end::Col--> 

                        </div>
                        <!--end::Input group-->

                        <!--begin::Input group-->
                        <div class="row mb-6">
                            <!--begin::Label-->
                            <label class="col-lg-4 col-form-label fw-bold fs-6">
                            <span class="required">Timezone</span>

                            <i
                                class="fas fa-exclamation-circle ms-1 fs-7"
                                data-bs-toggle="tooltip"
                                title="Timezone"
                            ></i>
                            </label>
                            <!--end::Label-->

                            <!--begin::Col-->
                            <div class="col-lg-8 fv-row">
                            <Field
                              as="select"
                              name="timezone"
                              class="form-select form-select-solid form-select-lg fw-bold"
                              
                            >
                            <option
                                v-for="i in timeZones"
                                :key="i"
                                :label="i.zone"
                                :value="i.zone"
                              >
                              </option>

                            </Field>
                            <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                <ErrorMessage name="timezone" />
                                </div>
                            </div>
                            </div>
                            <!--end::Col--> 

                        </div>
                        <!--end::Input group-->


                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="dbType"
                      />
                    </div>
                    <!--end::Input group-->
                  </div>
                </div>
                <!--end::Step 3-->

                <!--begin::Step 4-->
                <div data-kt-stepper-element="content" v-if="formData.encodingType !== 'activation'">
                  <div class="w-100">

                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row" v-if="formData.encodingType === 'regnew'">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Username</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify a username"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="username"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="username"
                      />
                    </div>
                    <!--end::Input group-->

                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row" v-if="formData.encodingType === 'regnew'"> 
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Password</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify a password"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="password"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="password"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="password"
                      />
                    </div>
                    <!--end::Input group-->
                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row" v-if="formData.encodingType === 'regnew'">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Confirm Password</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Confirm password"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="password"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="cpassword"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="cpassword"
                      />
                    </div>
                    <!--end::Input group--> 


                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row" v-if="formData.encodingType === 'regnew'">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">First Name</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify your first name"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="firstname"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="firstname"
                      />
                    </div>
                    <!--end::Input group-->

                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row" v-if="formData.encodingType === 'regnew'">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Middle Name</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify your middile name"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="mi"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="mi"
                      />
                    </div>
                    <!--end::Input group-->

                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row" v-if="formData.encodingType === 'regnew'">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Last Name</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify your last name"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="lastname"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="lastname"
                      />
                    </div>
                    <!--end::Input group-->

                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row" v-if="formData.encodingType === 'regnew'"> 
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Birth Date</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify your birth date"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="date"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="bd"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="bd"
                      />
                    </div>
                    <!--end::Input group-->


                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Sponsor ID</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify a sponsor ID"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="sponsorid"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="sponsorid"
                      />
                    </div>
                    <!--end::Input group-->
                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">Upline ID</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify a upline ID"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="uplineid"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="uplineid"
                      />
                    </div>
                    <!--end::Input group-->
 

                    <!--begin::Input group-->
                    <div class="row mb-10">
                      <!--begin::Col-->
                      <div class="col-md-8 fv-row">
                        <!--begin::Label-->
                        <label class="required fs-6 fw-bold form-label mb-2"
                          >Position</label
                        >
                        <!--end::Label-->

                        <!--begin::Row-->
                        <div class="row fv-row">
                          <!--begin::Col-->
                          <div class="col-6">
                            <Field
                              name="position"
                              class="form-select form-select-solid select2-hidden-accessible"
                              placeholder="Position"
                              as="select"
                            >
                                <option :value="''" :label="''"></option>
                                <option :value="'L'" :label="'Left'"></option>
                                <option :value="'R'" :label="'Right'"></option>
                            </Field>
                            <ErrorMessage
                              class="fv-plugins-message-container invalid-feedback"
                              name="position"
                            />
                          </div>
                          <!--end::Col-->
 
                        </div>
                        <!--end::Row-->
                      </div>
                      <!--end::Col-->
 
                    </div>
                    <!--end::Input group-->


                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">User ID</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify a user ID"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="userid"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="userid"
                      />
                    </div>
                    <!--end::Input group-->


                    <!--begin::Input group-->
                    <div class="d-flex flex-column mb-7 fv-row">
                      <!--begin::Label-->
                      <label
                        class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                      >
                        <span class="required">PIN</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify a PIN"
                        ></i>
                      </label>
                      <!--end::Label-->

                      <Field
                        type="text"
                        class="form-control form-control-solid"
                        placeholder=""
                        name="securitypin"
                      />
                      <ErrorMessage
                        class="fv-plugins-message-container invalid-feedback"
                        name="securitypin"
                      />
                    </div>
                    <!--end::Input group-->
                    
                  </div>
                </div>
                <!--end::Step 4-->

                <!--begin::Step 5-->
                <div data-kt-stepper-element="content">
                  <div class="w-100 text-center">
                    <!--begin::Heading-->
                    <h1 class="fw-bolder text-dark mb-3">Confirm</h1>
                    <!--end::Heading-->

                    <!--begin::Description-->
                    <div class="text-muted fw-bold fs-3">
                        Please check all details before submitting.
                    </div>
                    <!--end::Description-->
                    <!--begin::Review Data-->
                    <div class="card mb-10">
                    <div class="card-header">
                        <h3 class="card-title">Review Your Details</h3>
                    </div>
                    <div class="card-body">
                      <div >
                        <ul class="list-group list-group-flush text-start">
                          <li class="list-group-item"><strong>Business Name:</strong> {{ formData.businessName }}</li>
                          <li class="list-group-item"><strong>Owner's First Name:</strong> {{ formData.prospectFirstName }}</li>
                          <li class="list-group-item"><strong>Owner's Last Name:</strong> {{ formData.prospectLastName }}</li>
                          <li class="list-group-item"><strong>Owner's Email:</strong> {{ formData.prospectEmail }}</li>
                          <li class="list-group-item"><strong>Contact Phone:</strong> {{ formData.prospectContactPhone }}</li>
                          <li class="list-group-item"><strong>Address Line 1:</strong> {{ formData.companyAddress }}</li>
                          <li class="list-group-item">
                            <strong>Country:</strong>
                            <span v-if="selectedCountry">{{ selectedCountry.name }}</span>
                            <span v-else>{{ formData.country }}</span>
                          </li>
                          <li class="list-group-item"><strong>State:</strong> {{ formData.countryState }}</li>
                          <li class="list-group-item">
                            <strong>City:</strong>
                            <span v-if="selectedCity">{{ selectedCity.name }}</span>
                            <span v-else>{{ formData.city }}</span>
                          </li>
                          <li class="list-group-item"><strong>Postal Code:</strong> {{ formData.postalCode }}</li>
                          <li class="list-group-item"><strong>Timezone:</strong> {{ formData.timezone }}</li>
                          <li class="list-group-item"  v-if="formData.encodingType === 'regnew'" ><strong>Username:</strong> {{ formData.username }}</li> 
                          <li class="list-group-item"  v-if="formData.encodingType === 'regnew'" ><strong>First Name:</strong> {{ formData.firstname }}</li>
                          <li class="list-group-item"  v-if="formData.encodingType === 'regnew'"><strong>Middle Name:</strong> {{ formData.mi }}</li>
                          <li class="list-group-item"  v-if="formData.encodingType === 'regnew'"><strong>Last Name:</strong> {{ formData.lastname }}</li>
                          <li class="list-group-item"  v-if="formData.encodingType === 'regnew'"><strong>Birth Date:</strong> {{ formData.bd }}</li>
                          <li class="list-group-item"  v-if="['regnew', 'regmultiple'].includes(formData.encodingType)" ><strong>Sponsor ID:</strong> {{ formData.sponsorid }}</li>
                          <li class="list-group-item"  v-if="['regnew', 'regmultiple'].includes(formData.encodingType)"><strong>Upline ID:</strong> {{ formData.uplineid }}</li>
                          <li class="list-group-item"  v-if="['regnew', 'regmultiple'].includes(formData.encodingType)"><strong>Position:</strong> {{ formData.position }}</li>
                          <li class="list-group-item"  v-if="['regnew', 'regmultiple'].includes(formData.encodingType)"><strong>User ID:</strong> {{ formData.userid }}</li>
                          <li class="list-group-item"  v-if="['regnew', 'regmultiple'].includes(formData.encodingType)"><strong>PIN:</strong> {{ formData.securitypin }}</li>
                        </ul>
                      </div> 
                    </div>
                    </div>
                    <!--end::Review Data-->

                  </div>
                </div>
                <!--end::Step 5-->

                <!--begin::Actions-->
                <div class="d-flex flex-stack pt-10">
                  <!--begin::Wrapper-->
                  <div class="me-2">
                    <button
                      type="button"
                      class="btn btn-lg btn-light-primary me-3"
                      data-kt-stepper-action="previous"
                      @click="previousStep()"
                      :disabled="isSubmitting"
                    >
                      <span class="svg-icon svg-icon-3 me-1">
                        <inline-svg
                          src="media/icons/duotone/Navigation/Left-2.svg"
                        />
                      </span>
                      Back
                    </button>
                  </div>
                  <!--end::Wrapper-->

                  <!--begin::Wrapper-->
                  <div>
                    <button
                      type="button"
                      class="btn btn-lg btn-primary"
                      v-if="currentStepIndex === totalSteps - 1"
                      @click="formSubmit()"
                      :disabled="isSubmitting"
                    >
                      <span class="indicator-label">
                        Submit
                        <span class="svg-icon svg-icon-3 ms-2 me-0">
                          <inline-svg
                            src="icons/duotone/Navigation/Right-2.svg"
                          />
                        </span>
                      </span>
                      <span class="indicator-progress">
                        Please wait...
                        <span
                          class="spinner-border spinner-border-sm align-middle ms-2"
                        ></span>
                      </span>
                    </button>

                    <button type="submit" class="btn btn-lg btn-primary" v-else>
                      Continue
                      <span class="svg-icon svg-icon-3 ms-1 me-0">
                        <inline-svg
                          src="media/icons/duotone/Navigation/Right-2.svg"
                        />
                      </span>
                    </button>
                  </div>
                  <!--end::Wrapper-->
                </div>
                <!--end::Actions-->
              </form>
              <!--end::Form-->
            </div>
            <!--end::Content-->
          </div>
          <!--end::Stepper-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>
  <!--end::Modal - Create App-->
</template>

<style lang="scss" scoped>
.el-input--suffix .el-input__inner {
  background-color: #f5f8fa;
}

.el-input__inner {
  background-color: #f5f8fa;
}
</style>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import { StepperComponent } from "@/assets/ts/components/_StepperComponent";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useForm } from "vee-validate";
import { Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { getcountries, getcities, getTimeZones } from "@/api/common";
import { activateConfirm, activateSave } from "@/api/ai";

import { confirm_register, save_register, validateMultiple, saveRegMultiple } from "@/api/register";
  

interface  Step1 {
  businessName: string; 
}

interface Step2 {
  prospectFirstName: string;
  prospectLastName: string;
  prospectEmail: string;
}

interface Step3 {
    prospectContactPhone: string;
    companyAddress: string;
    country: string;
    country_text: string;
    city_text: string;
    countryState: string;
    city: string;
    postalCode: string;
    timezone: string;
}

interface Step4 {
    username: string;
    password: string;
    cpassword: string;
    firstname: string;
    lastname: string;
    mi: string;
    bd : string;
    sponsorid: string;
    uplineid: string;
    position: string; 
    userid: string;
    securitypin: string;
    encodingType: string;
    aiActivation: string;
    shoudDisplayRegistrationConfirmation: boolean;

    //to  cater regmultiple
    spid: string;
    upid: string;
    usid: string;
    secpin: string; 
    activationRecid: number;

}

interface KTCreateApp extends Step1, Step2, Step3, Step4 {}

export default defineComponent({
  name: "create-app-modal",
  components: {
    Field,
    ErrorMessage
  },
  props: {
    activation: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  setup(props) {
    const _stepperObj = ref<StepperComponent | null>(null);
    const createAppRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(0);

    const formData = ref<KTCreateApp>({
            businessName: "", 
            prospectFirstName: "",
            prospectLastName: "",
            prospectEmail: "",
            prospectContactPhone: "",
            companyAddress: "",
            country: "",
            country_text: "",
            countryState: "",
            city: "",
            city_text: "",
            postalCode: "",
            timezone: "",
            username: "",
            password: "",
            cpassword: "",
            firstname: "",
            lastname: "",
            mi: "",
            bd : "",
            sponsorid: "",
            uplineid: "",
            position: "",  
            userid: "",
            securitypin: "",
            encodingType: "activation",
            aiActivation: "",
            shoudDisplayRegistrationConfirmation: false,
            spid: "",
            upid: "",
            usid: "",   
            secpin: "",
            activationRecid: 0
    });

    onMounted(() => {
      _stepperObj.value = StepperComponent.createInsance(
        createAppRef.value as HTMLElement
      );
      httpGetCountries();
      httpGetTimeZones();
    });

    const createAppSchema = [
      Yup.object({
        businessName: Yup.string()
          .required()
          .label("Business name"), 
      }),
      Yup.object({
        prospectFirstName: Yup.string()
          .required()
          .label("First Name")
      }),
      Yup.object({
        prospectLastName: Yup.string()
          .required()
          .label("Last Name")
      }), 
      Yup.object({
        country: Yup.string()
          .required()
          .label("Country")
      }),
    ];

    // extracts the individual step schema
    const currentSchema = computed(() => {
      return createAppSchema[currentStepIndex.value];
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    const { resetForm, handleSubmit } = useForm<Step1 | Step2 | Step3 | Step4>({
      validationSchema: currentSchema
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const handleStep = handleSubmit(values => {
      formData.value = {
        ...formData.value,
        ...values
      };

      currentStepIndex.value++;

      if (!_stepperObj.value) {
        return;
      }

      _stepperObj.value.goNext();
    });

    const isSubmitting = ref(false);

    const formSubmit = async () => {


      formData.value.country_text = selectedCountry.value ? selectedCountry.value.iso_code_2 : '';
      formData.value.city_text = selectedCity.value ? selectedCity.value.name : '';
      formData.value.shoudDisplayRegistrationConfirmation = false;

      formData.value.spid = formData.value.sponsorid;
      formData.value.upid = formData.value.uplineid;
      formData.value.usid = formData.value.userid;
      formData.value.secpin = formData.value.securitypin;
      formData.value.activationRecid = props.activation?.recid || 0;

        isSubmitting.value = true;
        if(formData.value.encodingType === 'regnew'){ 
           const response: any =   await confirm_register(formData.value);
           isSubmitting.value = false;
          if(response.data !== undefined && response.data.result !== "SUCCESS") {  
            Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
            });  
            if (!_stepperObj.value) {
              isSubmitting.value = false;
              return;
            }
            currentStepIndex.value = 0;
            _stepperObj.value.goFirst();
            isSubmitting.value = false;
            return;
          } 
          formData.value.shoudDisplayRegistrationConfirmation = true;

                 Swal.fire({
                    title: "Confirm Submission",
                    html: `
                      <div class="fw-bold">
                        <h4 class="text-gray-800 fw-bolder">Network Setup confirmation</h4>
                        <div class="fs-6 text-gray-600">
                          ${formData.value.firstname}, you are requesting to register a new account with
                          <a class="fw-bolder" href="javascript:;">${response.data?.sponsorname} (${formData.value.sponsorid})</a> as your Sponsor and you
                          will be placed on the <a class="fw-bolder" href="javascript:;">${formData.value.position === 'L' ? 'Left' : 'Right'}</a> below your upline
                          <a class="fw-bolder" href="javascript:;">${response.data?.uplinename} (${response.data?.actualuplineid})</a>
                          ${formData.value.uplineid !== response.data?.actualuplineid ?
                            `<div class='pt-5'>Your original requested upline is <a class='fw-bolder' href='javascript:;'>${response.data?.requesteduplinename} (${formData.value.uplineid})</a></div>` : ''} 
                        </div>
                      </div>
                    `,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Yes, submit",
                    cancelButtonText: "Cancel",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                      cancelButton: "btn fw-bold btn-light"
                    }
                  }).then(async result => {
                    if (result.isConfirmed) {
                      // Place your submission logic here
                      // For example: window.location.reload();
                        isSubmitting.value = true;
                        const response2: any =   await save_register(formData.value);  
                        isSubmitting.value = false;
                        if(response2.data !== undefined && response2.data.result === "FAILED") {  
                            Swal.fire({
                                title: "",
                                text: response2.data.message,
                                icon: "error",
                                confirmButtonClass: "btn btn-secondary"
                            });  
                            if (!_stepperObj.value) {
                                return;
                            }
                            currentStepIndex.value = 0;
                            _stepperObj.value.goFirst();
                            return;
                        }  
                        
                        if(response2.data !== undefined && response2.data.result === "SUCCESS") {
                                Swal.fire({
                                    text: response2.data.message,
                                    icon: "success",
                                    buttonsStyling: false,
                                    confirmButtonText: "Ok",
                                    customClass: {
                                    confirmButton: "btn fw-bold btn-light-primary"
                                    }
                                }).then(() => {
                                    window.location.reload();
                                });
                        }

                    }
                  });
                return;        
            }
            



        isSubmitting.value = true;
        if(formData.value.encodingType === 'regmultiple'){ 
           const response: any =   await validateMultiple(formData.value);
           isSubmitting.value = false;
          if(response.data !== undefined && response.data.result !== "SUCCESS") {  
            Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
            });  
            if (!_stepperObj.value) {
              isSubmitting.value = false;
              return;
            }
            currentStepIndex.value = 0;
            _stepperObj.value.goFirst();
            isSubmitting.value = false;
            return;
          } 
          formData.value.shoudDisplayRegistrationConfirmation = true;

                 Swal.fire({
                    title: "Confirm Submission",
                    html: `
                        <div class="d-flex flex-stack flex-grow-1">
                        <div class="fw-bold">
                            <h4 class="text-gray-800 fw-bolder">Network Setup confirmation</h4>
                            <div class="fs-6 text-gray-600">
                            ${response?.data?.fullname}, you are requesting to register a new account with
                            <a class="fw-bolder" href="javascript:;">${response?.data?.sponsorname} (${formData.value.spid})</a> as your Sponsor and you
                            will be placed on the <a class="fw-bolder" href="javascript:;">${formData.value.position === 'L' ? 'Left' : 'Right'}</a> below your upline
                            <a class="fw-bolder" href="javascript:;">${response?.data?.uplinename} (${response?.data?.actualuplineid})</a>
                            ${formData.value.upid !== response?.data?.actualuplineid ?
                                `<div class='pt-5'>Your original requested upline is <a class='fw-bolder' href='javascript:;'>${response?.data?.requesteduplinename} (${formData.value.upid})</a></div>` : ''}
                            <div class="pt-5">
                                Please click Submit to Proceed
                            </div>
                            </div>
                        </div>
                        </div>
                    `,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Yes, submit",
                    cancelButtonText: "Cancel",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                        cancelButton: "btn fw-bold btn-light"
                    }
                    }).then(async result => {
                    if (result.isConfirmed) {
                      // Place your submission logic here
                      // For example: window.location.reload();
                        isSubmitting.value = true;
                        const response2: any =   await saveRegMultiple(formData.value);  
                        isSubmitting.value = false;
                        if(response2.data !== undefined && response2.data.result === "FAILED") {  
                            Swal.fire({
                                title: "",
                                text: response2.data.message,
                                icon: "error",
                                confirmButtonClass: "btn btn-secondary"
                            });  
                            if (!_stepperObj.value) {
                                return;
                            }
                            currentStepIndex.value = 0;
                            _stepperObj.value.goFirst();
                            return;
                        }  
                        
                        if(response2.data !== undefined && response2.data.result === "SUCCESS") {
                                Swal.fire({
                                    text: response2.data.message,
                                    icon: "success",
                                    buttonsStyling: false,
                                    confirmButtonText: "Ok",
                                    customClass: {
                                    confirmButton: "btn fw-bold btn-light-primary"
                                    }
                                }).then(() => {
                                    window.location.reload();
                                });
                        }

                    }
                  });
                return;        
            }



        isSubmitting.value = true;
        if(formData.value.encodingType === 'activation'){ 
           const response: any =   await activateConfirm(formData.value);
           isSubmitting.value = false;
          if(response.data !== undefined && response.data.result !== "SUCCESS") {  
            Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
            });  
            if (!_stepperObj.value) {
              isSubmitting.value = false;
              return;
            }
            currentStepIndex.value = 0;
            _stepperObj.value.goFirst();
            isSubmitting.value = false;
            return;
          } 
          formData.value.shoudDisplayRegistrationConfirmation = true;

                 Swal.fire({
                    title: "Confirm Submission",
                    text: `You are requesting to activate Business AI for the ${formData.value.businessName}. Please click Submit to Proceed`,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Yes, submit",
                    cancelButtonText: "Cancel",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                        cancelButton: "btn fw-bold btn-light"
                    }
                    }).then(async result => {
                    if (result.isConfirmed) {
                      // Place your submission logic here
                      // For example: window.location.reload();
                        isSubmitting.value = true;
                        const response2: any =   await activateSave(formData.value);  
                        isSubmitting.value = false;
                        if(response2.data !== undefined && response2.data.result === "FAILED") {  
                            Swal.fire({
                                title: "",
                                text: response2.data.message,
                                icon: "error",
                                confirmButtonClass: "btn btn-secondary"
                            });  
                            if (!_stepperObj.value) {
                                return;
                            }
                            currentStepIndex.value = 0;
                            _stepperObj.value.goFirst();
                            return;
                        }  
                        
                        if(response2.data !== undefined && response2.data.result === "SUCCESS") {
                                Swal.fire({
                                    text: response2.data.message,
                                    icon: "success",
                                    buttonsStyling: false,
                                    confirmButtonText: "Ok",
                                    customClass: {
                                    confirmButton: "btn fw-bold btn-light-primary"
                                    }
                                }).then(() => {
                                    window.location.reload();
                                });
                        }

                    }
                  });
                return;        
            }
          
    };

    resetForm({
      values: {
        ...formData.value
      }
    });



    
    const countries = ref([]) as any; 
    const cities = ref([]) as any;   
    const timeZones = ref([]) as any;   
    const countriesLoading = ref(true);
    const citiesLoading = ref(true);

    const httpGetCountries = async () => {
      countriesLoading.value = true;
      countries.value = [];
      const response = await getcountries();
      if (response.data?.countries) {
        countries.value = response.data.countries;
      }
      countriesLoading.value = false;
    };

    const httpGetTimeZones =  async () => { 
      timeZones.value = [];
        const response = await getTimeZones(); 
        if(response.data !== undefined && response.data.timezones !== undefined) { 
          timeZones.value = response.data.timezones; 
        }
    }; 

    const getCities = async (country_id) => {
      citiesLoading.value = true;
      cities.value = [];
      const response = await getcities(country_id);
      if (response.data?.cities) {
        cities.value = response.data.cities;
      }
      citiesLoading.value = false;
    };

    const selectedCountry = computed(() => {
      const countryId = parseInt(formData.value.country, 10);
      return countries.value.find(c => parseInt(c.country_id, 10) === countryId) || null;
    });
    const selectedCity = computed(() => {
      const cityId = parseInt(formData.value.city, 10);
      return cities.value.find(city => parseInt(city.zone_id, 10) === cityId) || null;
    });
 

    return {
        countriesLoading,
        citiesLoading,
        countries, 
        selectedCountry,
        selectedCity,
        getCities,
        cities,
        timeZones,
        handleStep,
        formSubmit,
        previousStep,
        createAppRef,
        currentStepIndex,
        totalSteps,
        formData,
        isSubmitting
    };
  }
});
</script>
